module.exports = __webpack_public_path__ + "img/f12.1fbf64e8.png";